<section class="title-bar">
  <div class="main-area">
    <div *ngIf="mainTitle"
         class="main-title">
      <rappider-button *ngIf="displayGripButton"
                       [icon]="{name: 'fa-regular fa-grip-dots-vertical', type: IconType.FontAwesome}"
                       [size]="ButtonSize.ExtraSmall"
                       [tooltipText]="mainTitleButton.tooltipText"
                       (confirm)="onGripButtonClick()"></rappider-button>

      <!-- <button *ngIf="displayGripButton"
              nz-button
              nzType="default"
              nz-size="small"
              class="grip-button"
              (click)="onGripButtonClick()">



        <i class="fa-regular fa-grip-dots-vertical"></i>
      </button> -->
      <rappider-heading [content]="mainTitle.content"
                        [type]="mainTitle.type"></rappider-heading>
    </div>

    <!-- ----------------------------------------------------------------------------------------- -->
    <!-- BREADCRUMB -->
    <div *ngIf="options?.length && displayBreadcrumb"
         class="breadcrumb-area">
      <rappider-icon *ngIf="actionIcon && actionIcon?.name"
                     [name]="actionIcon.name"
                     [type]="actionIcon.type"
                     [theme]="actionIcon.theme"
                     [color]="actionIcon.color"
                     [size]="actionIcon.size"
                     (click)="onActionIconClick()"></rappider-icon>
      <rappider-breadcrumb [options]="options"
                           [cssStyle]="cssStyle"
                           (optionClick)="onOptionClick($event)">
      </rappider-breadcrumb>
    </div>
    <!-- / BREADCRUMB -->
    <!-- ----------------------------------------------------------------------------------------- -->
  </div>
  <div class="bar-buttons">
    <!-- ----------------------------------------------------------------------------------------- -->

    <!-- RADIO BUTTONS -->
    <div *ngIf="radioButtonSettings">
      <rappider-radio [options]="radioButtonSettings"
                      [showOptionsAsButtons]="true"
                      (valueChange)="onRadioButtonValueChange($event)">

      </rappider-radio>
    </div>
    <!-- BUTTONS -->
    <ng-container *ngFor="let actionButton of actionButtons">
      <div *ngIf="actionButton?.joyride?.joyrideStep"
          [joyrideStep]="actionButton?.joyride?.joyrideStep"
           [title]="actionButton?.joyride?.title"
           [text]="actionButton?.joyride?.text"
           (next)="onClickActionButton(actionButton)"
           (done)="onJoyrideDoneButtonClick()"
           >
        <rappider-button *ngIf="actionButton?.visible !== false && actionButton?.titleBarView !== ButtonTitleBarView.Dropdown"
                        [text]="actionButton.text"
                        [type]="actionButton.type"
                        [shape]="actionButton.shape"
                        [size]="actionButton.size"
                        [transparent]="actionButton.transparent"
                        [loading]="actionButton.loading"
                        [block]="actionButton.loading"
                        [disabled]="actionButton.disabled"
                        [colorType]="actionButton.colorType"
                        [icon]="actionButton.icon"
                        [emitWithoutPopconfirm]="actionButton.emitWithoutPopconfirm"
                        [popconfirmTitle]="actionButton.popconfirmTitle"
                        [formButtonType]="actionButton?.formButtonType"
                        [borderSettings]="actionButton?.borderSettings"
                        [customSizeSettings]="actionButton?.customSizeSettings"
                        [customColorSettings]="actionButton?.customColorSettings"
                        [shadowSettings]="actionButton?.shadowSettings"
                        [paddingSettings]="actionButton?.paddingSettings"
                        [marginSettings]="actionButton?.marginSettings"
                        [tooltipText]="actionButton?.tooltipText"
                        [tooltipPlacement]="actionButton?.tooltipPlacement"
                        (confirm)="onClickActionButton(actionButton)"></rappider-button>
      </div>
      <div *ngIf="!actionButton?.joyride?.joyrideStep">
      <rappider-button *ngIf="actionButton?.visible !== false && actionButton?.titleBarView !== ButtonTitleBarView.Dropdown"
                      [text]="actionButton.text"
                      [type]="actionButton.type"
                      [shape]="actionButton.shape"
                      [size]="actionButton.size"
                      [transparent]="actionButton.transparent"
                      [loading]="actionButton.loading"
                      [block]="actionButton.loading"
                      [disabled]="actionButton.disabled"
                      [colorType]="actionButton.colorType"
                      [icon]="actionButton.icon"
                      [emitWithoutPopconfirm]="actionButton.emitWithoutPopconfirm"
                      [popconfirmTitle]="actionButton.popconfirmTitle"
                      [formButtonType]="actionButton?.formButtonType"
                      [borderSettings]="actionButton?.borderSettings"
                      [customSizeSettings]="actionButton?.customSizeSettings"
                      [customColorSettings]="actionButton?.customColorSettings"
                      [shadowSettings]="actionButton?.shadowSettings"
                      [paddingSettings]="actionButton?.paddingSettings"
                      [marginSettings]="actionButton?.marginSettings"
                      [tooltipText]="actionButton?.tooltipText"
                      [tooltipPlacement]="actionButton?.tooltipPlacement"
                      (confirm)="onClickActionButton(actionButton)"></rappider-button>

      </div>

    </ng-container>

    <a *ngIf="isDropdownVisible"
        nz-dropdown
        nzPlacement="leftTop"
        nzTrigger="click"
        [nzDropdownMenu]="menu">
      <i nz-icon
          nzType="ellipsis"
          nzTheme="outline"></i>
    </a>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <ng-container *ngFor="let action of actionButtons; let itemActionIndex = index">
          <ng-container *ngIf="action?.titleBarView === ButtonTitleBarView.Dropdown">
            <li class="action-drop-down-menu-item"
                nz-menu-item
                nz-popconfirm
                [nzPopconfirmTitle]="action.popconfirmTitle"
                [nzDisabled]="action.disabled"
                (nzOnConfirm)="onColumnActionConfirm(action)"
                (click)="onColumnActionClick(action)">
              <div class="action-drop-down-menu-item-row">
                <div *ngIf="action.icon"
                      class="dropdown-menu-item-icon">
                  <rappider-icon [name]="action.icon.name"
                                 [color]="action.icon.color"
                                 [type]="action.icon.type"
                                 [theme]="action.icon.theme"
                                 [size]="action.icon.size"></rappider-icon>
                </div>
                <div *ngIf="action.text"
                      class="dropdown-menu-item-text">
                  <span>{{ action.text | translate }}</span>
                </div>
              </div>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </nz-dropdown-menu>

    <!-- / BUTTONS -->
    <!-- ----------------------------------------------------------------------------------------- -->

    <div class="title-bar-right">
      <div *ngIf="switchSettings && isSwitchVisible"
           class="title-bar-right-item">
        <rappider-switch nz-tooltip
                         [nzTooltipTitle]="switchSettings?.tooltipText"
                         [ngModel]="switchChecked"
                         [text]="switchSettings?.text"
                         [size]="switchSettings?.size"
                         [textPosition]="switchSettings?.textPosition"
                         [loading]="switchSettings?.loading"
                         (valueChange)="onSwitchValueChanged($event)"></rappider-switch>
      </div>

      <!-- ----------------------------------------------------------------------------------------- -->
      <!-- MENU -->
      <div *ngIf="dropdownMenu"
           class="title-bar-right-item">
        <rappider-dropdown-menu [items]="dropdownMenu?.items"
                                [label]="dropdownMenu?.label"
                                [icon]="dropdownMenu?.icon"
                                [triggerType]="dropdownMenu?.triggerType"
                                [placement]="dropdownMenu?.placement"
                                [labelMode]="dropdownMenu?.labelMode"
                                (menuItemClick)="onMenuItemClick($event)"></rappider-dropdown-menu>
      </div>

      <!-- / MENU -->
      <!-- ----------------------------------------------------------------------------------------- -->

    </div>
  </div>
</section>
